import React, { useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import ImageViewer from "../../../components/ImageViewer";
import ActionButton from "../../../components/ActionButton";
import { BsDashLg, BsPlusLg } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { Badge } from "react-bootstrap";
import { getPreviousFundRequestById, getFundRequest4LowPriceOnItemId } from "../../../services/contractorApi";
import { useEffect } from "react";
import Stack from "react-bootstrap/Stack";
import CardComponent from "../../../components/CardComponent";
import { getpunchrequestitemdetails } from "../../../services/contractorApi";
import { ItemRemarksCell, useItemRemarkMap } from "../../../components/ItemRemarks";
import { useActionGate } from "../../../utils/menuNodes";
import { formatAmountINR, to3 } from "../../../utils/helper";

export const ViewFundRequest = ({ edit, hideAmountSummary = false }) => {
  // every item's Request / Approve / Transfer remarks, in each table's Remarks column
  // The Transfer line's Transaction ID / Remark — and the item remarks — are
  // edited here, in the item tables, with the "Edit Transaction ID / Remark"
  // right of the Transferred tab (the list's separate Edit button is gone).
  const canActOn = useActionGate("/FundManagement");
  const canEditTransfer = canActOn("fund-transfer-transferred", "edit_details", false);
  const itemRemarks = useItemRemarkMap("fund", edit?.id);
  let statusColor = "";
  let statusText = "";
  const [previousFundAmount, setPreviousFundAmount] = useState(0);
  const [previousFundAmountData, setPreviousFundAmountData] = useState([]);
  const [expenseRequestDetails, setRequestDetails] = useState([]);
  const [lowPrice, setLowPrice] = useState({});

  switch (+edit?.status) {
    case 0:
      statusColor = "#D9512C"; // Pending
      statusText = "Pending";
      break;
    case 1:
      statusColor = "green"; // Approved
      statusText = "Approved";
      break;
    case 2:
      statusColor = "red"; // Reject
      statusText = "Rejected";
      break;
    case 3:
      statusColor = "orange"; // Hold
      statusText = "On Hold";
      break;
    case 4:
      statusColor = "blue"; // Partial
      statusText = "Partial";
      break;
    case 5:
      statusColor = "green"; // Done
      statusText = "Done";
      break;
  }

  const [collapsedRows, setCollapsedRows] = useState({});
  const { t } = useTranslation();
  const toggleRow = (section, index) => {
    const rowKey = `${section}-${index}`;
    setCollapsedRows((prev) => {
      const nextRows = { ...prev };
      if (nextRows[rowKey]) {
        delete nextRows[rowKey];
        return nextRows;
      }
      nextRows[rowKey] = true;
      return nextRows;
    });
  };
  const isRowExpanded = (section, index) =>
    Boolean(collapsedRows[`${section}-${index}`]);

  const getPreviousFundRequestDetails = async (id, requestId) => {
    const res = await getPreviousFundRequestById(id, requestId);
    if (res.status) {
      setPreviousFundAmount(res?.finalBalance);
      setPreviousFundAmountData(res?.data);
    } else {
      setPreviousFundAmount(0);
    }
  };

  const fetchPunchRequestItemDetails = async (id) => {
    const res = await getpunchrequestitemdetails(id);
    if (res.status) {
      setRequestDetails(res?.data);
      // setPreviousFundAmountData(res?.data);
    } else {
      setRequestDetails([]);
    }
  };

  useEffect(() => {
    if (edit?.request_for_id) {
      getPreviousFundRequestDetails(edit?.request_for_id, "null");
      fetchPunchRequestItemDetails(edit?.request_for_id);
    }
    const fetchLowPriceForItems = async (items) => {
      for (const itm of items || []) {
        const hsncode = itm?.item_name?.hsncode;
        if (hsncode) {
          const res = await getFundRequest4LowPriceOnItemId(hsncode, "fund", edit?.request_for_id);
          if (res.status) {
            setLowPrice((prev) => ({ ...prev, [hsncode]: res.data }));
          }
        }
      }
    };
    fetchLowPriceForItems(edit?.request_fund?.request_fund);
    fetchLowPriceForItems(edit?.approved_data?.request_fund);
    fetchLowPriceForItems(edit?.transfer_data?.transfer_fund);
    fetchLowPriceForItems(edit?.rescheduled_data?.reschedule_fund);
  }, [edit]);
  return (
    <Row className="g-3">
      {/* <CardComponent  showCardHeader={true} showCardHeader={true} header={t("Request By Details")}></CardComponent> */}

      <Col md={6}>
        <div className="p-20 shadow rounded h-100">
          <strong className="text-secondary">{t("Request By Details")}</strong>
          <div className="mt-2">
            <table className="table-sm table">
              <tbody>
                <tr>
                  <th>{t("Username")} :</th>
                  <td>
                    {edit?.request_for ?? "--"}
                    {/* employee ID under the name (the API sends request_for_employee_id) */}
                    {edit?.request_for_employee_id ? (
                      <div className="small text-muted">{edit.request_for_employee_id}</div>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <th>{t("Current Balance")} :</th>
                  <td style={{ color: "green", fontWeight: "600" }}>
                    {edit?.user_balance != null ? formatAmountINR(edit?.user_balance) : "--"}
                  </td>
                </tr>
             {!hideAmountSummary && <tr>
  <th>
    {t(
      edit?.status == 2
        ? "Rejected Amount"
        : "Request Amount"
    )}{" "}
    :
  </th>
  <td style={{ color: "green", fontWeight: "600" }}>
    {formatAmountINR(edit?.total_request_amount ?? 0)}
  </td>
</tr>}
                <tr>
                  <th>{t("Request Date")} :</th>
                  <td>{edit?.request_date ?? "--"}</td>
                </tr>
                  {(edit?.status == 1 || edit?.status == 2) && (
                  <tr>
                    <th>
                      {edit?.status == 2 ? t("Rejected By") : t("Approved By")}{" "}
                      :
                    </th>
                    <td>{edit?.approved_by_name ?? "--"}</td>
                  </tr>
                )}
                {(edit?.status == 1 || edit?.status == 2) && (
                  <tr>
                    <th>
                      {edit?.status == 2
                        ? t("Reject Date")
                        : t("Approved Date")}{" "}
                      :
                    </th>
                    <td>{edit?.approved_at ?? "--"}</td>
                  </tr>
                )}
                {(edit?.status == 1 ||
                  edit?.status == 4 ||
                  edit?.status == 5) && (
                  <tr>
                    <th>{t("Approved Amount")} :</th>
                    <td style={{ color: "green", fontWeight: "600" }}>
                      {formatAmountINR(edit?.total_approved_amount ?? 0)}
                    </td>
                  </tr>
                )}
                {(edit?.status == 4 || edit?.status == 5) && (
                  <tr>
                    <th>
                      {edit?.status == 4
                        ? t("Partially Transferred Amount")
                        : t("Transferred Amount")}{" "}
                      :
                    </th>
                    <td style={{ color: "green", fontWeight: "600" }}>
                      {formatAmountINR(
                        edit?.transfer_data?.transfer_fund?.reduce(
                          (userTotal, item) =>
                            userTotal + +item?.request_transfer_fund,
                          0
                        ) || 0
                      )}
                    </td>
                  </tr>
                )}
                {/* <tr>
                  <th>{t("Punched Amount")} :</th>
                  <td style={{ color: "green", fontWeight: "600" }}>
                    {formatAmountINR(previousFundAmountData[0]?.total_amount_punched ?? 0)}
                  </td>
                </tr> */}
                {!hideAmountSummary &&
                  (edit?.status == 1 ||
                    edit?.status == 4 ||
                    edit?.status == 5) && (
                  <tr>
                    <th>{t("Remaining Transfer Amount")} :</th>
                    <td style={{ color: "green", fontWeight: "600" }}>
                      {/* Simple, same-scope: this request's approved minus this
                          request's transferred (total_transfer_amount). The old
                          calc subtracted the item's CUMULATIVE transfer, which
                          mixed scopes and showed negative. */}
                      {formatAmountINR(
                        (edit?.total_approved_amount ?? 0) -
                          (edit?.total_transfer_amount ?? 0)
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Col>
      <Col md={6}>
        <div className="p-20 shadow rounded h-100">
          <strong className="text-secondary">{t("Fund Details")}</strong>
          <div className="mt-2">
            <table className="table-sm table">
              <tbody>
                <tr>
                  <th>{t("Status")} :</th>
                  <td style={{ color: statusColor }}>{statusText}</td>
                </tr>
              
                <tr>
                  <th>{t("Fund Limit")} :</th>
                  <td style={{ color: "green", fontWeight: "600" }}>
                    {formatAmountINR(previousFundAmountData[0]?.fund_limit ?? 0)}
                  </td>
                </tr>
                <tr>
                  <th>{t("Total Fund Transferred")} :</th>
                  <td style={{ color: "green", fontWeight: "600" }}>
                    {formatAmountINR(previousFundAmountData[0]?.total_transfer_amount ?? 0)}
                  </td>
                </tr>
                <tr>
                  <th>{t("Remaining Fund Limit")} :</th>
                  <td style={{ color: "green", fontWeight: "600" }}>
                    {formatAmountINR(
                      (previousFundAmountData[0]?.fund_limit ?? 0) -
                        (edit?.user_balance ?? 0)
                    )}
                  </td>
                </tr>
                <tr>
                  <th>{t("Fund Punched")} :</th>
                  <td style={{ color: "green", fontWeight: "600" }}>
                    {formatAmountINR(previousFundAmountData[0]?.total_amount_punched ?? 0)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Col>

      {edit?.request_fund?.request_fund?.length > 0 && edit?.status == 2 && (
        <Col md={12}>
          <div className="p-20 shadow rounded h-100">
            <strong className="text-secondary">Requested Data</strong>
            <div className="mt-2">
              <Table
                responsive
                className="table-sm table Roles"
                style={{ minWidth: "max-content" }}
              >
                <thead>
                  <tr>
                    <th>{t("Sr No.")}</th>
                    <th>{t("Item Name")}</th>
                    <th>{t("HSN Code")}</th>
                    <th>{t("Brand")}</th>
                    <th>{t("prev Price")}</th>
                    <th>{t("Prev user stock")}</th>
                    <th>{t("request price")}</th>
                    <th>{t("request stock")}</th>
                    <th>{t("Lowest Rate")}</th>
                    <th>{t("Supplier")}</th>
                    <th>{t("request amount")}</th>
                    <th>{t("Action")}</th>
                    <th>{t("Remarks")}</th>
                  </tr>
                </thead>
                <tbody>
                  {edit?.request_fund?.request_fund?.map((itm, idx) => (
                    <>
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>
                          <div className="d-flex">
                            <ImageViewer
                              src={
                                itm.item_name?.image
                                  ? process.env.REACT_APP_API_URL +
                                    itm.item_name?.image
                                  : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                              }
                            >
                              <img
                                src={
                                  itm.item_name?.image
                                    ? process.env.REACT_APP_API_URL +
                                      itm.item_name?.image
                                    : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                }
                                className="avatar me-2"
                              />
                            </ImageViewer>
                            <span className="small d-grid">
                              <span>{itm.item_name?.label}</span>
                              <span className="text-gray">
                                {itm.item_name?.unique_id
                                  ? `(${itm.item_name?.unique_id})`
                                  : "-"}
                              </span>
                            </span>
                          </div>
                        </td>
                        <td>{itm.item_name?.hsncode || "-"}</td>
                        <td>{itm.rate?.label || "-"}</td>
                        <td>{formatAmountINR(itm.previous_price)}</td>
                        <td>{to3(itm.current_user_stock)}</td>
                        <td>{formatAmountINR(itm.new_price)}</td>
                        <td>{to3(itm.request_quantity)}</td>
                        <td>
                          {(() => {
                            const prices = lowPrice[itm.item_name?.hsncode];
                            if (!prices || prices.length === 0) return "-";
                            const minItem = prices.reduce((min, item) =>
                              !min || +item.item_rate < +min.item_rate ? item : min, null
                            );
                            return minItem ? formatAmountINR(minItem.item_rate) : "-";
                          })()}
                        </td>
                        <td>
                          {(() => {
                            const prices = lowPrice[itm.item_name?.hsncode];
                            if (!prices || prices.length === 0) return "-";
                            const minItem = prices.reduce((min, item) =>
                              !min || +item.item_rate < +min.item_rate ? item : min, null
                            );
                            return minItem?.supplier_name || "-";
                          })()}
                        </td>
                        <td>{formatAmountINR(itm.fund_amount)}</td>
                        <td>
                          <span
                            className={`cursor-pointer text-${
                              isRowExpanded("rejected-request", idx)
                                ? "danger"
                                : "green"
                            }`}
                            onClick={() => toggleRow("rejected-request", idx)}
                          >
                            {isRowExpanded("rejected-request", idx) ? (
                              <BsDashLg fontSize={"large"} />
                            ) : (
                              <BsPlusLg fontSize={"large"} />
                            )}
                          </span>
                        </td>
                        <td>
                          <ItemRemarksCell remarks={itemRemarks} path={`0:request_fund:${idx}`} stages={["raised", "approved", "transferred"]} canEdit={canEditTransfer} canEditTransfer={canEditTransfer} />
                        </td>
                      </tr>
                      {isRowExpanded("rejected-request", idx) && (
                        <tr>
                          <td className="text-start" colSpan="12">
                            <span className="fw-bold">{t("Description")}:</span>{" "}
                            {itm.description}
                          </td>
                        </tr>
                      )}
                    </>
                  ))}
                  <tr>
                    <td colSpan={9}></td>
                    <td colSpan={1} className="fw-bold ">
                      {t("total request amt")} -
                    </td>
                    <td className="text-start  fw-bold">
                      <b>
                        {formatAmountINR(
                          edit?.request_fund?.request_fund.reduce(
                            (userTotal, item) => userTotal + +item.fund_amount,
                            0
                          )
                        )}{" "}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </Col>
      )}

      {edit?.request_fund?.request_fund?.length > 0 &&
        (edit?.status == 0 || edit?.status == 2 || edit?.status == 1) && (
          <Col md={12}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary">
                {edit?.status == 0 || edit?.status == 1
                  ? t("Request Data")
                  : t("  Rejected Data")}
              </strong>
              <div className="mt-2">
                <Table
                  responsive
                  className="table-sm table Roles"
                  style={{ minWidth: "max-content" }}
                >
                  <thead>
                    <tr>
                      <th>{t("Sr No.")}</th>
                      <th>{t("Item Name")}</th>
                      <th>{t("HSN Code")}</th>
                      <th>{t("Brand")}</th>
                      <th>{t("prev Price")}</th>
                      <th>{t("Prev user stock")}</th>
                      <th>{t("request price")}</th>
                      <th>{t("request stock")}</th>
                      <th>{t("Lowest Rate")}</th>
                      <th>{t("Supplier")}</th>
                      <th>{t("request amount")}</th>
                      <th>{t("Action")}</th>
                      <th>{t("Remarks")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {edit?.request_fund?.request_fund?.map((itm, idx) => (
                      <>
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>
                            <div className="d-flex">
                              <ImageViewer
                                src={
                                  itm.item_name?.image
                                    ? process.env.REACT_APP_API_URL +
                                      itm.item_name?.image
                                    : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                }
                              >
                                <img
                                  src={
                                    itm.item_name?.image
                                      ? process.env.REACT_APP_API_URL +
                                        itm.item_name?.image
                                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                  }
                                  className="avatar me-2"
                                />
                              </ImageViewer>
                              <span className="small d-grid">
                                <span>{itm.item_name?.label}</span>
                                <span className="text-gray">
                                  {itm.item_name?.unique_id
                                    ? `(${itm.item_name?.unique_id})`
                                    : "-"}
                                </span>
                              </span>
                            </div>
                          </td>
                          <td>{itm.item_name?.hsncode || "-"}</td>
                          <td>{itm.rate?.label || "-"}</td>
                          <td>{formatAmountINR(itm.previous_price)}</td>
                          <td>{to3(itm.current_user_stock)}</td>
                          <td>{formatAmountINR(itm.new_price)}</td>
                          <td>{to3(itm.request_quantity)}</td>
                          <td>
                            {(() => {
                              const prices = lowPrice[itm.item_name?.hsncode];
                              if (!prices || prices.length === 0) return "-";
                              const minItem = prices.reduce((min, item) =>
                                !min || +item.item_rate < +min.item_rate ? item : min, null
                              );
                              return minItem ? formatAmountINR(minItem.item_rate) : "-";
                            })()}
                          </td>
                          <td>
                            {(() => {
                              const prices = lowPrice[itm.item_name?.hsncode];
                              if (!prices || prices.length === 0) return "-";
                              const minItem = prices.reduce((min, item) =>
                                !min || +item.item_rate < +min.item_rate ? item : min, null
                              );
                              return minItem?.supplier_name || "-";
                            })()}
                          </td>
                          <td>{formatAmountINR(itm.fund_amount)}</td>
                          <td>
                            <span
                              className={`cursor-pointer text-${
                                isRowExpanded("request", idx)
                                  ? "danger"
                                  : "green"
                              }`}
                              onClick={() => toggleRow("request", idx)}
                            >
                              {isRowExpanded("request", idx) ? (
                                <BsDashLg fontSize={"large"} />
                              ) : (
                                <BsPlusLg fontSize={"large"} />
                              )}
                            </span>
                          </td>
                          <td>
                            <ItemRemarksCell remarks={itemRemarks} path={`0:request_fund:${idx}`} stages={["raised", "approved", "transferred"]} canEdit={canEditTransfer} canEditTransfer={canEditTransfer} />
                          </td>
                        </tr>
                        {isRowExpanded("request", idx) && (
                          <tr>
                            <td className="text-start" colSpan="12">
                              <span className="fw-bold">
                                {t("Description")}:
                              </span>{" "}
                              {itm.description}
                            </td>
                          </tr>
                        )}
                      </>
                    ))}
                    <tr>
                      <td colSpan={9}></td>
                      <td colSpan={1} className="fw-bold ">
                        {t("total request amt")} -
                      </td>
                      <td className="text-start  fw-bold">
                        <b>
                          {formatAmountINR(
                            edit?.request_fund?.request_fund.reduce(
                              (userTotal, item) => userTotal + +item.fund_amount,
                              0
                            )
                          )}{" "}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        )}

      {edit?.request_fund?.new_request_fund?.length > 0 &&
        (edit?.status == 0 || edit?.status == 2) && (
          <Col md={12}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary">
                {" "}
                {t("New Request Data")}
              </strong>
              <div className="mt-2">
                <Table
                  responsive
                  className="table-sm table Roles"
                  style={{ minWidth: "max-content" }}
                >
                  <thead>
                    <tr>
                      <th>{t("Sr No.")}</th>
                      <th>{t("Item Name")}</th>
                      <th>{t("request price")}</th>
                      <th>{t("request stock")}</th>
                      <th>{t("request amount")}</th>
                      <th>{t("Action")}</th>
                      <th>{t("Remarks")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {edit?.request_fund?.new_request_fund?.map((itm, idx) => (
                      <>
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>
                            <div className="d-flex">
                              <ImageViewer
                                src={
                                  itm?.item_image
                                    ? itm?.item_image
                                    : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                }
                              >
                                <img
                                  width={35}
                                  height={35}
                                  className="my-bg object-fit p-1 rounded-circle"
                                  src={
                                    itm?.item_image
                                      ? itm?.item_image
                                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                  }
                                />{" "}
                              </ImageViewer>
                              <span className="m-2 ">{itm?.title?.value}</span>
                            </div>
                          </td>

                          <td>{formatAmountINR(itm?.rate)}</td>
                          <td>{to3(itm?.qty)}</td>
                          <td>{formatAmountINR(itm.fund_amount)}</td>
                          <td>
                            <span
                              className={`cursor-pointer text-${
                                isRowExpanded("new-request", idx)
                                  ? "danger"
                                  : "green"
                              }`}
                              onClick={() => toggleRow("new-request", idx)}
                            >
                              {isRowExpanded("new-request", idx) ? (
                                <BsDashLg fontSize={"large"} />
                              ) : (
                                <BsPlusLg fontSize={"large"} />
                              )}
                            </span>
                          </td>
                          <td>
                            <ItemRemarksCell remarks={itemRemarks} path={`0:new_request_fund:${idx}`} stages={["raised", "approved", "transferred"]} canEdit={canEditTransfer} canEditTransfer={canEditTransfer} />
                          </td>
                        </tr>
                        {isRowExpanded("new-request", idx) && (
                          <tr>
                            <td className="text-start" colSpan="8">
                              <span className="fw-bold">
                                {t("Description")}:
                              </span>{" "}
                              {itm?.description}
                            </td>
                          </tr>
                        )}
                      </>
                    ))}
                    <tr>
                      <td colSpan={3}></td>
                      <td colSpan={1} className="fw-bold">
                        {t("total request amt")} -
                      </td>
                      <td className="text-start ">
                        <b>
                          {formatAmountINR(
                            edit?.request_fund?.new_request_fund.reduce(
                              (userTotal, item) => userTotal + +item.fund_amount,
                              0
                            )
                          )}
                        </b>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}></td>
                      <td colSpan={1} className="fw-bold fs-6">
                        {t("Final Amount")} -
                      </td>
                      <td className="text-start fw-bold fs-6">
                        {formatAmountINR(edit?.total_request_amount)}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        )}

      {(edit?.approved_data?.request_fund?.length > 0 ||
        edit?.approved_data?.new_request_fund?.length > 0) && (
        <>
          {/* <Col md={12}>
              <div className="p-20 shadow rounded h-100">
                <strong className="text-secondary">{t("Approved Fund")}</strong>
                <div className="mt-2">
                  <table className="table-sm table">
                    <tbody>
                      <tr>
                        <th>{t("Status")} :</th>
                        <td style={{ color: statusColor }}>{statusText}</td>
                      </tr>
                      <tr>
                        <th>{t("approved by")} :</th>
                        <td>
                          <ImageViewer
                            src={
                              edit.approved_image
                                ? `${process.env.REACT_APP_API_URL}${edit.approved_image}`
                                : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                            }
                          >
                            <img
                              width={35}
                              height={35}
                              className="my-bg object-fit p-1 rounded-circle"
                              src={
                                edit.approved_image
                                  ? `${process.env.REACT_APP_API_URL}${edit.approved_image}`
                                  : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                              }
                            />{" "}
                          </ImageViewer>
                          {edit?.approved_by_name} - {edit?.approved_employee_id}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("approved at")} :</th>
                        <td>{edit?.approved_at}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Col> */}

          {edit?.approved_data?.request_fund?.length > 0 &&
            (edit?.status == 1 || edit?.status == 4 || edit?.status == 5) && (
              <Col md={12}>
                <div className="p-20 shadow rounded h-100">
                  <strong className="text-secondary">
                    {t("Approved Item")}
                  </strong>
                  <div className="mt-2">
                    <Table
                      responsive
                      className="table-sm table Roles"
                      style={{ minWidth: "max-content" }}
                    >
                      <thead>
                        <tr>
                          <th>{t("Sr No.")}</th>
                          <th>{t("Item Name")}</th>
                          <th>{t("HSN Code")}</th>
                          <th>{t("Brand")}</th>
                          <th>{t("Previous Price")}</th>
                          <th>{t("Request Price")}</th>
                          <th>{t("Request quantity")}</th>
                          <th>{t("approve price")}</th>
                          <th>{t("approve quantity")}</th>
                          <th>{t("Lowest Rate")}</th>
                          <th>{t("Supplier")}</th>
                          <th>{t("Fund Amount")}</th>
                          <th>{t("Action")}</th>
                          <th>{t("Remarks")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {edit?.approved_data?.request_fund.map((itm, idx) => (
                          <React.Fragment key={idx}>
                            <tr>
                            <td>{idx + 1}</td>
                            <td>
                              <div className="d-flex">
                                <ImageViewer
                                  src={
                                    itm.item_name?.image
                                      ? process.env.REACT_APP_API_URL +
                                        itm.item_name?.image
                                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                  }
                                >
                                  <img
                                    src={
                                      itm.item_name?.image
                                        ? process.env.REACT_APP_API_URL +
                                          itm.item_name?.image
                                        : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                    }
                                    className="avatar me-2"
                                  />
                                </ImageViewer>
                                <span className="small d-grid">
                                  <span>{itm.item_name?.label}</span>
                                  <span className="text-gray">
                                    {itm.item_name?.unique_id
                                      ? `(${itm.item_name?.unique_id})`
                                      : "-"}
                                  </span>
                                </span>
                              </div>
                            </td>
                            <td>{itm.item_name?.hsncode || "-"}</td>
                            <td>{itm.rate?.label || "-"}</td>
                            <td>{formatAmountINR(itm?.previous_price)}</td>
                            <td>{formatAmountINR(itm?.new_price)}</td>
                            <td> {to3(itm.request_quantity)}</td>
                            <td>{formatAmountINR(itm.price)}</td>
                            <td> {to3(itm.quantity)}</td>
                            <td>
                              {(() => {
                                const prices = lowPrice[itm.item_name?.hsncode];
                                if (!prices || prices.length === 0) return "-";
                                const minItem = prices.reduce((min, item) =>
                                  !min || +item.item_rate < +min.item_rate ? item : min, null
                                );
                                return minItem ? formatAmountINR(minItem.item_rate) : "-";
                              })()}
                            </td>
                            <td>
                              {(() => {
                                const prices = lowPrice[itm.item_name?.hsncode];
                                if (!prices || prices.length === 0) return "-";
                                const minItem = prices.reduce((min, item) =>
                                  !min || +item.item_rate < +min.item_rate ? item : min, null
                                );
                                return minItem?.supplier_name || "-";
                              })()}
                            </td>
                            <td>{formatAmountINR(itm.price * itm.quantity)}</td>
                            <td>
                              <span
                                className={`cursor-pointer text-${
                                  isRowExpanded("approved", idx)
                                    ? "danger"
                                    : "green"
                                }`}
                                onClick={() => toggleRow("approved", idx)}
                              >
                                {isRowExpanded("approved", idx) ? (
                                  <BsDashLg fontSize={"large"} />
                                ) : (
                                  <BsPlusLg fontSize={"large"} />
                                )}
                              </span>
                            </td>
                            <td>
                              <ItemRemarksCell remarks={itemRemarks} path={`0:request_fund:${idx}`} stages={["raised", "approved", "transferred"]} canEdit={canEditTransfer} canEditTransfer={canEditTransfer} />
                            </td>
                          </tr>
                          {isRowExpanded("approved", idx) && (
                            <tr>
                              <td className="text-start" colSpan="13">
                                <span className="fw-bold">
                                  {t("Description")}:
                                </span>{" "}
                                {itm?.description || "--"}
                              </td>
                            </tr>
                          )}
                          </React.Fragment>
                        ))}
                        <tr>
                          <td colSpan={11}></td>
                          <td colSpan={1} className="fw-bold">
                            {t("total approved amt")}.
                          </td>
                          <td className="text-start fw-bold">
                            <b>
                              {formatAmountINR(
                                edit?.approved_data?.request_fund.reduce(
                                  (userTotal, item) =>
                                    userTotal + +item?.quantity * item?.price,
                                  0
                                )
                              )}
                            </b>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Col>
            )}

          {edit?.approved_data?.new_request_fund?.length > 0 &&
            (edit?.status == 1 || edit?.status == 4) && (
              <Col md={12}>
                <div className="p-20 shadow rounded h-100">
                  <strong className="text-secondary">
                    {t("New Approved Item")}
                  </strong>
                  <div className="mt-2">
                    <Table
                      responsive
                      className="table-sm table Roles"
                      style={{ minWidth: "max-content" }}
                    >
                      <thead>
                        <tr>
                          <th>{t("Sr No.")}</th>
                          <th>{t("Item Name")}</th>
                          <th>{t("HSN Code")}</th>
                          <th>{t("Requested Price")}</th>
                          <th>{t("Requested quantity")}</th>
                          <th>{t("total request amount")}</th>
                          <th>{t("Approved Price")}</th>
                          <th>{t("Approved quantity")}</th>
                          <th>{t("total approved amount")}</th>
                          <th>{t("Action")}</th>
                          <th>{t("Remarks")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {edit?.approved_data?.new_request_fund.map(
                          (itm, idx) => (
                            <React.Fragment key={idx}>
                              <tr>
                              <td>{idx + 1}</td>
                              <td>
                                <div className="d-flex">
                                  <ImageViewer
                                    src={
                                      itm?.item_image
                                        ? itm?.item_image
                                        : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                    }
                                  >
                                    <img
                                      width={35}
                                      height={35}
                                      className="my-bg object-fit p-1 rounded-circle"
                                      src={
                                        itm?.item_image
                                          ? itm?.item_image
                                          : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                      }
                                    />{" "}
                                  </ImageViewer>

                                  <span className="m-2">
                                    {itm?.title?.value}
                                  </span>
                                </div>
                              </td>
                              <td>{itm?.hsncode}</td>
                              <td>{formatAmountINR(itm?.requested_rate)}</td>
                              <td>{to3(itm?.requested_qty)}</td>
                              <td>
                                {formatAmountINR(itm.requested_rate * itm.requested_qty)}
                              </td>
                              <td>{formatAmountINR(itm?.rate)}</td>
                              <td>{to3(itm?.qty)}</td>
                              <td>{formatAmountINR(itm?.rate * itm?.qty)}</td>
                              <td>
                                <span
                                  className={`cursor-pointer text-${
                                    isRowExpanded("new-approved", idx)
                                      ? "danger"
                                      : "green"
                                  }`}
                                  onClick={() => toggleRow("new-approved", idx)}
                                >
                                  {isRowExpanded("new-approved", idx) ? (
                                    <BsDashLg fontSize={"large"} />
                                  ) : (
                                    <BsPlusLg fontSize={"large"} />
                                  )}
                                </span>
                              </td>
                              <td>
                                <ItemRemarksCell remarks={itemRemarks} path={`0:new_request_fund:${idx}`} stages={["raised", "approved", "transferred"]} canEdit={canEditTransfer} canEditTransfer={canEditTransfer} />
                              </td>
                            </tr>
                            {isRowExpanded("new-approved", idx) && (
                              <tr>
                                <td className="text-start" colSpan="10">
                                  <span className="fw-bold">
                                    {t("Description")}:
                                  </span>{" "}
                                  {itm?.description || "--"}
                                </td>
                              </tr>
                            )}
                            </React.Fragment>
                          )
                        )}
                        <tr>
                          <td colSpan={6}></td>
                          <td colSpan={2} className="fw-bold">
                            {t("total approved amt")}.
                          </td>
                          <td className="text-start fw-bold">
                            <b>
                              {formatAmountINR(
                                edit?.approved_data?.new_request_fund.reduce(
                                  (userTotal, item) =>
                                    userTotal + +item?.qty * item?.rate,
                                  0
                                )
                              )}
                            </b>
                          </td>
                        </tr>

                        <tr>
                          <td colSpan={6}></td>
                          <td colSpan={2} className="fs-6 fw-bold">
                            {t("Final Approved Amount")}
                          </td>
                          <td className="text-start fs-6 fw-bold" colSpan={2}>
                            <b>{formatAmountINR(edit?.total_approved_amount)}</b>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Col>
            )}
        </>
      )}

      {(edit?.transfer_data?.transfer_fund?.length > 0 ||
        edit?.transfer_data?.new_transfer_fund?.length) > 0 && (
        <>
          {/* <Col md={12}>
              <div className="p-20 shadow rounded h-100">
                <strong className="text-secondary">{t("Transfer Fund")}</strong>
                <div className="mt-2">
                  <table className="table-sm table">
                    <tbody>
                      <tr>
                        <th>{t("Status")} :</th>
                        <td style={{ color: statusColor }}>{statusText}</td>
                      </tr>
                      <tr>
                        <th>{t("approved by")} :</th>
                        <td>
                          <ImageViewer
                            src={
                              edit.approved_image
                                ? `${process.env.REACT_APP_API_URL}${edit.approved_image}`
                                : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                            }
                          >
                            <img
                              width={35}
                              height={35}
                              className="my-bg object-fit p-1 rounded-circle"
                              src={
                                edit.approved_image
                                  ? `${process.env.REACT_APP_API_URL}${edit.approved_image}`
                                  : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                              }
                            />{" "}
                          </ImageViewer>
                          {edit?.approved_by_name} - {edit?.approved_employee_id}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("approved at")} :</th>
                        <td>{edit?.approved_at}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Col> */}

          {edit?.transfer_data?.transfer_fund?.length > 0 &&
            (edit?.status == 5 || edit?.status == 4) && (
              <Col md={12}>
                <div className="p-20 shadow rounded h-100">
                  <strong className="text-secondary">
                    {" "}
                    {t("Transfer Item")}{" "}
                  </strong>
                  <div className="mt-2">
                    <Table
                      responsive
                      className="table-sm table Roles"
                      style={{ minWidth: "max-content" }}
                    >
                      <thead>
                        <tr>
                          <th>{t("Sr No.")}</th>
                          <th>{t("Item Name")}</th>
                          <th>{t("Brand")}</th>
                          <th>{t("HSN Code")}</th>
                          <th>{t("prev price")}</th>
                          <th>{t("current stock")}</th>
                          <th>{t("Item rate")}</th>
                          <th>{t("request qty")}</th>
                          <th>{t("total request amount")}</th>
                          <th>{t("approve qty")}</th>
                          <th>{t("approve price")}</th>
                          <th>{t("Lowest Rate")}</th>
                          <th>{t("Supplier")}</th>
                          <th>{t("Transfer Quantity")}</th>
                          <th>{t("total transfer amount")}</th>
                          <th>{t("Action")}</th>
                          <th>{t("Remarks")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {edit?.transfer_data?.transfer_fund.map((itm, idx) => (
                          <React.Fragment key={idx}>
                            <tr>
                            <td>{idx + 1}</td>
                            <td>
                              <div className="d-flex">
                                <ImageViewer
                                  src={
                                    itm.item_name?.image
                                      ? process.env.REACT_APP_API_URL +
                                        itm.item_name?.image
                                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                  }
                                >
                                  <img
                                    src={
                                      itm.item_name?.image
                                        ? process.env.REACT_APP_API_URL +
                                          itm.item_name?.image
                                        : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                    }
                                    className="avatar me-2"
                                  />
                                </ImageViewer>
                                <span className="small d-grid">
                                  {/* <span>{itm.item_name?.label}</span> */}
                                  <span className="text-gray">
                                    {itm.item_name?.unique_id
                                      ? `(${itm.item_name?.unique_id})`
                                      : "-"}
                                  </span>
                                </span>
                              </div>
                            </td>
                            <td>{itm.rate?.label || "-"}</td>
                            <td>{itm?.item_name?.hsncode}</td>
                            <td>{formatAmountINR(itm.previous_price)}</td>
                            <td>{to3(itm.current_user_stock)}</td>
                            <td>{formatAmountINR(itm.new_price)}</td>
                            <td>{to3(itm.request_quantity)}</td>
                            <td>{formatAmountINR(itm.fund_amount)}</td>
                            <td>{to3(itm.quantity)}</td>
                            <td>{formatAmountINR(itm.price)}</td>
                            <td>
                              {(() => {
                                const prices = lowPrice[itm.item_name?.hsncode];
                                if (!prices || prices.length === 0) return "-";
                                const minItem = prices.reduce((min, item) =>
                                  !min || +item.item_rate < +min.item_rate ? item : min, null
                                );
                                return minItem ? formatAmountINR(minItem.item_rate) : "-";
                              })()}
                            </td>
                            <td>
                              {(() => {
                                const prices = lowPrice[itm.item_name?.hsncode];
                                if (!prices || prices.length === 0) return "-";
                                const minItem = prices.reduce((min, item) =>
                                  !min || +item.item_rate < +min.item_rate ? item : min, null
                                );
                                return minItem?.supplier_name || "-";
                              })()}
                            </td>
                            <td> {to3(itm.transfer_quantity)}</td>
                            <td>{formatAmountINR(itm.price * itm.transfer_quantity)}</td>
                            <td>
                              <span
                                className={`cursor-pointer text-${
                                  isRowExpanded("transfer", idx)
                                    ? "danger"
                                    : "green"
                                }`}
                                onClick={() => toggleRow("transfer", idx)}
                              >
                                {isRowExpanded("transfer", idx) ? (
                                  <BsDashLg fontSize={"large"} />
                                ) : (
                                  <BsPlusLg fontSize={"large"} />
                                )}
                              </span>
                            </td>
                            <td>
                              <ItemRemarksCell remarks={itemRemarks} path={`0:request_fund:${idx}`} stages={["raised", "approved", "transferred"]} canEdit={canEditTransfer} canEditTransfer={canEditTransfer} />
                            </td>
                          </tr>
                          {isRowExpanded("transfer", idx) && (
                            <tr>
                              <td className="text-start" colSpan="16">
                                <span className="fw-bold">
                                  {t("Description")}:
                                </span>{" "}
                                {itm?.description ||
                                  itm?.item_name?.description ||
                                  "--"}
                              </td>
                            </tr>
                          )}
                          </React.Fragment>
                        ))}
                        <tr>
                          <td colSpan={13}></td>
                          <td colSpan={1} className="fw-bold">
                            total Transfer amt.
                          </td>
                          <td className="text-start fw-bold">
                            <b>
                              {formatAmountINR(
                                edit?.transfer_data?.transfer_fund.reduce(
                                  (userTotal, item) =>
                                    userTotal + +item?.request_transfer_fund,
                                  0
                                ) || 0
                              )}
                            </b>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Col>
            )}


          {/* <Col md={12} className="mt-4">
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary">
                {t("Requested Puched Items")}
              </strong>
              <div className="mt-2">
                <Table className="table-sm table Roles">
                  <thead>
                    <tr>
                      <th>{t("Sr No.")}</th>
                      <th>{t("Item Name")}</th>
                      <th>{t("HSN Code")}</th>
                      <th>{t("Requested Qty")}</th>
                      <th>{t("Requested Rate")}</th>
                      <th>{t("Requested Amount")}</th>
                      <th>{t("Reschedule Reason")}</th>
                      <th>{t("Reschedule Date")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {edit?.rescheduled_items?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <ImageViewer
                              src={
                                item?.item_image
                                  ? item.item_image
                                  : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                              }
                            >
                              <img
                                width={35}
                                height={35}
                                className="my-bg object-fit p-1 rounded-circle me-2"
                                src={
                                  item?.item_image
                                    ? item.item_image
                                    : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                }
                                alt={item?.title?.value}
                              />
                            </ImageViewer>
                            <span>{item?.title?.value}</span>
                          </div>
                        </td>
                        <td>{item?.hsncode || "--"}</td>
                        <td>{item?.requested_qty || "0"}</td>
                        <td>₹{item?.requested_rate || "0"}</td>
                        <td>
                          ₹
                          {(item?.requested_qty || 0) *
                            (item?.requested_rate || 0)}
                        </td>
                        <td>{item?.reschedule_reason || "--"}</td>
                        <td>{item?.reschedule_date || "--"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </Col> */}
        </>
      )}
    </Row>
  );
};
